/**
 * Extrae el contenido de texto de un objeto de retro que puede tener diferentes formatos
 */
export function extractRetroContent(retroObj: unknown): string | null {
  if (!retroObj) return null;

  if (typeof retroObj === "string") {
    return retroObj;
  }

  if (
    typeof retroObj === "object" &&
    retroObj !== null &&
    "content" in retroObj &&
    typeof (retroObj as { content: unknown }).content === "string"
  ) {
    return (retroObj as { content: string }).content;
  }

  return null;
}

/**
 * Procesa el contenido Markdown convirtiendo etiquetas <br> en negrita
 */
export function processMarkdownContent(content: string): string {
  if (typeof content !== "string") return content;
  return content.replace(/<br>(.*?)<br>/g, "**$1**");
}

/**
 * Valida el tipo de archivo
 */
export function validateFileType(file: File, allowedTypes: string[]): boolean {
  return allowedTypes.some(
    (type) => file.type === type || file.name.endsWith(type)
  );
}

/**
 * Valida el tamaño del archivo
 */
export function validateFileSize(file: File, maxSizeMB: number): boolean {
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  return file.size <= maxSizeBytes;
}
